import { FrameEditEmailSettingsGroup, FrameListEmailSettings, FrameListEmailStatus } from '@Modules/Mailing';
import { Navigate, RouteObject } from 'react-router';
import { setupModuleRouting } from './setupModuleRouting';

export function setupMailingSettingsRouting(): RouteObject {
    return {
        path: 'mailing',
        children: [
            {
                path: '',
                element: <Navigate to="mandant" />,
            },
            {
                path: 'email_status',
                element: <FrameListEmailStatus />,
            },
            setupModuleRouting({
                resourcePath: 'mandant',
                listFrame: <FrameListEmailSettings name="mandant" />,
                editFrame: <FrameEditEmailSettingsGroup name="mandant" />,
            }),
        ],
    };
}
